import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"


import rules from '@/app/shared/domain/data/rules';
import InputCpf from '@/app/shared/components/inputs/InputCpf.vue';
import InputCnpj from './InputCnpj.vue';
import CnpjData from '../../domain/classes/CnpjData';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputDocument',
  props: ['modelValue'],
  emits: ['update:modelValue', 'cnpjDataFound'],
  setup(__props, { emit }) {

const props = __props;




const documentOptions = [
    { title: 'Cpf', value: 'cpf', },
    { title: 'Cnpj', value: 'cnpj', },
];

function updateModel(value: any, field: string) {    
    emit('update:modelValue', {
        ...props.modelValue,
        [field]: value,
    });
}

function cnpjDataFound(data: CnpjData) {    
    console.log('cnpjDataFound on inputDocument', data);
    emit('cnpjDataFound', data);
}

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_col, {
      cols: "12",
      sm: "6"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_select, {
          "model-value": __props.modelValue?.type,
          rules: [_unref(rules).required],
          label: "Tipo de documento",
          items: documentOptions,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (updateModel($event, 'type')))
        }, null, 8, ["model-value", "rules"])
      ]),
      _: 1
    }),
    (__props.modelValue?.type === 'cpf')
      ? (_openBlock(), _createBlock(_component_v_col, {
          key: 0,
          cols: "12",
          sm: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(InputCpf, {
              label: "Documento",
              "model-value": __props.modelValue?.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (updateModel($event, 'value')))
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.modelValue?.type === 'cnpj')
      ? (_openBlock(), _createBlock(_component_v_col, {
          key: 1,
          cols: "12",
          sm: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(InputCnpj, {
              label: "Documento",
              "model-value": __props.modelValue?.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (updateModel($event, 'value'))),
              onCnpjDataFound: cnpjDataFound
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})